import styled from "styled-components";
export const OptionalStyle = styled.div`
  font-family: Amazon Ember;
  font-size: 14px;
  font-style : italic;
  font-weight : 400;
`;

